import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import usePlayersContext from "../hooks/usePlayersContext";
import useEpisodePlayersContext from "../../../hooks/useEpisodePlayersContext";
import ApplePodcasts from "./SubscribeButtons/ApplePodcasts";
import Spotify from "./SubscribeButtons/Spotify";
import SubscribeButton from "./SubscribeButton";

const Subscribe = () => {
    const { showPopupSubscribe, popupSubscribe, episodeIndex } = usePlayersContext();
    const { data } = useEpisodePlayersContext();

    const googlePodcastsLink = data?.subscribe?.googlePodcasts?.link ?? data.episodes[episodeIndex]?.subscribe?.googlePodcasts?.link
    const applePodcastsLink = data?.subscribe?.applePodcasts?.link ?? data.episodes[episodeIndex]?.subscribe?.applePodcasts?.link
    const spotifyLink = data?.subscribe?.spotify?.link ?? data.episodes[episodeIndex]?.subscribe?.spotify?.link
    const rssFeedLink = data?.subscribe?.rssFeed?.link ?? data.episodes[episodeIndex]?.subscribe?.rssFeed?.link

    return (
        <>
            <SubscribeButton />
            {showPopupSubscribe && (
                <div className="player-app__item-popup episode-player-subscribe">
                    <button onClick={popupSubscribe} className="player-app__close-popup">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 4L4 12M4 4L12 12" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                    <Swiper
                        slidesPerView={2}
                        spaceBetween={10}
                        watchSlidesProgress={true}
                        allowTouchMove={false}
                        className="player-app__swiper"
                    >
                        {applePodcastsLink && (
                            <SwiperSlide>
                                <ApplePodcasts url={applePodcastsLink} />
                            </SwiperSlide>
                        )}
                        {spotifyLink && (
                            <SwiperSlide>
                                <Spotify url={spotifyLink} />
                            </SwiperSlide>
                        )}
                    </Swiper>
                </div>
            )}
        </>
    );
};

export default Subscribe;
